<template>
  <div style="height: 100%;background-color: #fff;">
    <div class="amount">
      <span style="font-family: ;">￥{{amount}}</span>
      <div class="left_time">
        支付剩余时间:
        <yd-countdown :time="countdown" timetype="second"></yd-countdown>
      </div>
    </div>
    <div v-show="wxtipShow === false">
      <div v-for="(pay, key) in payTypes" :key="key" class="pay_way"
           @click="chooseone(pay.val)">
        <span><img src="" :onerror="payImage(pay.val)" alt="">&nbsp;&nbsp;&nbsp;{{pay.description}}</span>
        <input type="radio" :value="pay.val" v-model="payType"/>
      </div>
      <yd-button size="large" type="primary" v-show="!Shenpi" @click.native="pay">支付</yd-button>
      <yd-button size="large" v-show="Shenpi">等待审批</yd-button>
    </div>
    <img v-show="wxtipShow" src="~assets/image/webg.png"
         style="display: none;background-repeat: no-repeat;background-size: 100% 100%;width: 100%; height: 100%;position: fixed">
  </div>
</template>
<script type="text/babel">
import axios from 'axios'

var interval

export default {
  data () {
    return {
      params: this.$route.params,
      payTypes: [],
      payImageData: {
        '1': 'this.src="' + require('../../assets/image/weixin.png') + '"',
        '2': 'this.src="' + require('../../assets/image/zhifubao.png') + '"',
        '3': 'this.src="' + require('../../assets/image/yinhang.png') + '"',
        '4': 'this.src="' + require('../../assets/image/xianjin.png') + '"',
        '10': 'this.src="' + require('../../assets/image/yinhang.png') + '"'
      },
      payType: '',
      Shenpi: false,
      amount: '',
      payStatus: false,
      countdown: 0,
      downShow: false,
      wxtipShow: false
    }
  },
  methods: {
    async checkOrder (check) {
      if (this.$route.path.indexOf('fair-pay') === -1) {
        clearInterval(interval)
        return false
      }
      let data = {id: this.params.order_id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token')
      await axios
        .post('/fair/order-cont', data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            this.amount = res.data.order.order_unpay
            if (res.data.order.countdown !== undefined) {
              this.downShow = true
              this.countdown = res.data.order.countdown
            }
            if (res.data.order.status < '1') {
              // 订单已失效！
              return false
            } else if (res.data.order.status === '10') {
              this.$dialog.toast({
                mes: '订单已支付'
              })
              this.$router.push({path: '/' + this.params.id + '/single-my'})
              this.payStatus = false
            }
            if (res.data.order.isneedshenpi === 1 && res.data.order.product_type !== '29') {
              // 等待审批
              this.$dialog.toast({
                mes: '等待审批'
              })
              this.Shenpi = true
              return false
            }
            if (check) {
              axios
                .post('/user/zhifu-setting', {orderid: this.params.order_id, fairid: this.params.id})
                .then(payTypes => {
                  payTypes = payTypes.data
                  if (payTypes.status === 1) {
                    payTypes.res.forEach(payType => {
                      if (payType.cloum_value === '1') {
                        this.payTypes.push(payType)
                      }
                    })
                    this.payStatus = true
                    interval = setInterval(this.checkOrder, 5000)
                  }
                })
            }
          }
        })
        .catch(function (res) {
          console.log(res)
        })
    },
    pay () {
      this.checkOrder()
      if (this.payStatus === false) {
        return false
      }
      if (this.payType === 1) {
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
          window.location.href = this.$store.state.api_url + 'site/get-openid?orderid=' + this.params.order_id
        } else {
          axios
            .get('/wechat-js/index?orderid=' + this.params.order_id + '&is_jiudian=0')
            .then(res => {
              res = res.data
              if (res.status === 1) {
                // window.location.href = 'wepay.html?wxurl=' + res.data
                this.$router.push({path: '/' + this.params.id + '/weixin-pay?url=' + res.data})
                return false
                window.location.href = res.data
              } else {
                this.$dialog.toast({
                  mes: res.msg
                })
              }
            })
        }
      } else if (this.payType === 2) {
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
          this.wxtipShow = true
        } else {
          var url = this.$store.state.api_url + 'alipay-m2/index'
          window.location.href = url + '?orderid=' + this.params.order_id
        }
      } else if (this.payType === 3) {
        this.$router.push({path: '/' + this.params.id + '/bank-transfer/' + this.params.order_id})
      } else if (this.payType === 4) {
        axios
          .post('/fair/remit', {orderid: this.params.order_id, payment: this.payType})
          .then(res => {
            res = res.data
            if (res.status === 1) {
              this.$router.push({path: '/' + this.params.id + '/single-my'})
            }
          })
      } else if (this.payType === 10) {
        let url = this.$store.state.frontend_url + '/unionpay/index?orderid=' + this.params.order_id
        window.location.href = url
      }
    },
    payImage (pay) {
      let img = ''
      if (this.payImageData[pay]) {
        img = this.payImageData[pay]
      }
      return img
    },
    HistoryBack () {
      window.history.back()
    },
    chooseone (val) {
      this.payType = val
    }
  },
  mounted () {
    this.checkOrder(1)
  }
}
</script>

<style lang="stylus" scoped>
  .amount
    text-align: center
    padding: .4rem 0

  .amount span
    color: #f00
    font-size: .6rem

  .left_time
    color: #333
    font-size: .24rem

  .left_time span
    color: #333
    font-size: .24rem

  .yd-cell-item
    padding: 0 .4rem

  .yd-cell-item:not(:last-child)::after
    opacity: 0.4
    width: calc(100% - .8rem)
    margin-left: .4rem

  .pay_way
    padding: 0 .4rem
  .pay_way > :first-child
    line-height: .8rem !important
  .pay_way>:nth-child(2)>:nth-child(2)::after
    display: none!important

  .pay_way img
    width: .4rem
  .pay_way input
    float: right
    height: .8rem
</style>



// WEBPACK FOOTER //
// src/views/template1/FairPay.vue